import React from "react"
import { Box } from "@chakra-ui/core"
import TextInput from "./text-input"

const EmailInput = ({ ...props }) => <TextInput type="email" {...props} />

export default EmailInput
